import ThematicCarousel from "./ThematicCarousel";
export default ThematicCarousel;
